<router-outlet></router-outlet>
<app-concierge-widget></app-concierge-widget>
<ui-cookies-info (actionClick)="onCookiesAcceptClick($event)" *ngIf="showCookiesInfo"></ui-cookies-info>
